import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, VENDOR_LABELS } from "@/lib/api";
import ClickTrendChart from "@/components/admin/ClickTrendChart";

const RANGES = [
  { days: 7, label: "7 days" },
  { days: 30, label: "30 days" },
  { days: 0, label: "All time" },
];
const SRC = [
  { key: "main", label: "Main button", color: "#FF3366" },
  { key: "look", label: "Complete the look", color: "#4D00FF" },
  { key: "season", label: "Season pages", color: "#00A86B" },
  { key: "other", label: "Other", color: "#BDBDBD" },
];

const ShareBar = ({ row }) => (
  <div className="flex h-3 w-full border-2 border-black bg-white">
    {SRC.map((s) => row[s.key] > 0 && (
      <div key={s.key} style={{ width: `${(row[s.key] / row.total) * 100}%`, backgroundColor: s.color }} title={`${s.label}: ${row[s.key]}`} />
    ))}
  </div>
);

export default function ClickInsights() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/admin/clicks/by-source", { params: { days } }).then((r) => setData(r.data));
  }, [days]);

  return (
    <div className="brut bg-white p-5 space-y-4" data-testid="click-insights">
      <div className="flex items-center gap-2 flex-wrap">
        <h2 className="font-display text-2xl tracking-tight">Button insights</h2>
        <div className="ml-auto flex gap-2">
          {RANGES.map((r) => (
            <button key={r.days} onClick={() => setDays(r.days)} data-testid={`click-insights-range-${r.days}`}
              className={`brut px-2 py-1 font-mono uppercase text-[10px] tracking-widest brut-press ${days === r.days ? "pcs-bg-blue text-white" : "bg-white"}`}>
              {r.label}
            </button>
          ))}
        </div>
      </div>
      <ClickTrendChart days={days} />
      {!data ? (
        <div className="font-mono uppercase text-xs tracking-widest opacity-60">Loading...</div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            {[{ key: "total", label: "All clicks", color: "#0A0A0A" }, ...SRC].map((s) => (
              <div key={s.key} className="brut p-3" data-testid={`click-insights-total-${s.key}`}>
                <div className="font-mono uppercase text-[10px] tracking-widest opacity-70 flex items-center gap-1.5">
                  <span className="w-2.5 h-2.5 border border-black" style={{ backgroundColor: s.color }} />{s.label}
                </div>
                <div className="font-display text-3xl">{data.totals[s.key]}</div>
              </div>
            ))}
          </div>
          {data.items.length === 0 ? (
            <div className="text-sm opacity-70" data-testid="click-insights-empty">No clicks in this period.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="click-insights-table">
                <thead className="font-mono uppercase text-[10px] tracking-widest pcs-bg-orange">
                  <tr>
                    {["Product", "Vendor", "Main", "Look", "Season", "Other", "Total", "Share"].map((h) => (
                      <th key={h} className="text-left p-2 border-b-2 border-black">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.items.map((r) => (
                    <tr key={r.slug} className="border-b border-black/20" data-testid={`click-insights-row-${r.slug}`}>
                      <td className="p-2 max-w-xs truncate"><Link to={`/product/${r.slug}`} className="font-bold hover:pcs-text-pink">{r.title}</Link></td>
                      <td className="p-2 font-mono uppercase text-[11px]">{VENDOR_LABELS[r.vendor] || r.vendor}</td>
                      <td className="p-2 font-mono">{r.main}</td>
                      <td className="p-2 font-mono">{r.look}</td>
                      <td className="p-2 font-mono">{r.season}</td>
                      <td className="p-2 font-mono opacity-60">{r.other}</td>
                      <td className="p-2 font-display text-lg">{r.total}</td>
                      <td className="p-2 w-40"><ShareBar row={r} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <p className="font-mono text-[10px] opacity-60">Clicks recorded before button tracking was added count as "Other".</p>
        </>
      )}
    </div>
  );
}
